/** Action sidebar pendant le tour onboarding (ticket #654). */

export type OnboardingOpenSidebarAction =
  | 'open-mobile-drawer'
  | 'expand-desktop-sidebar';

/** Seuil aligné PrivateLayout / Sidebar (768px). */
export function resolveOnboardingOpenSidebarAction(
  viewportWidth: number
): OnboardingOpenSidebarAction {
  return viewportWidth < 768 ? 'open-mobile-drawer' : 'expand-desktop-sidebar';
}
